module.exports = __webpack_public_path__ + "static/img/zzzs.3d38865.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/img/zzzs.png
// module id = PDvK
// module chunks = 3